import { FormControlLabel, Typography } from '@mui/material'
import { parseLabel } from '../../parseLabel'
import Checkbox from 'app/views/common-components/CustomCheckbox'

export const FormBooleanPrint = ({
  id,
  title,
  value,
  disabled,
  typeProps,
  langVersion,
  ...props
}) => {
  const parsedTitle = parseLabel(title)

  return (
    <FormControlLabel
      control={<Checkbox disabled checked={Boolean(value)} />}
      label={<Typography className='form-read-only-text form-parsed-text'>{parsedTitle}</Typography>}
    />
  )
}
